import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { locationOffer } from "../../constants";
import Footer from "../../CustomComponents/Footer/Footer.jsx";
// import DestinationLinks from "../../CustomComponents/DestinationLinks/DestinationLinks.jsx";
import Highlights from "../../CustomComponents/Highlights/Highlights.jsx";
import Testimonial from "../../CustomComponents/Testimonial/Testimonial.jsx";
import BannerMain from "../../CustomComponents/BannerMain/BannerMain.jsx";
import CustomSearchFormHolidays from "../../CustomComponents/SearchForm/CustomSearchFormHolidays/CustomSearchFormHolidays.jsx";
import { showErrorToast } from "../../assets/toastUtils.js";
import PageMetaData from "../../CustomComponents/PageMetaData/PageMetaData.jsx";
import FilterHotels from "../../CustomComponents/FilterHotels/FilterHotels.jsx";
import AllDestinationsSlider from "../../CustomComponents/AllDestinationsSlider/AllDestinationsSlider.jsx";
import NewHotelsSearchForm from "../../CustomComponents/SearchForm/NewHotelsSearchForm/NewHotelsSearchForm.jsx";
import DestinationLinks from "../../CustomComponents/DestinationLinks/DestinationLinks.jsx";
import HotelsList from "../../CustomComponents/HotelsList/HotelsList.jsx";
import HotelChains from "../../CustomComponents/HotelChains/HotelChains.jsx";
import OgMetaTitles from "../../CustomComponents/PageMetaData/OgMetaTitles.jsx";
import HotelCard from "../../CustomComponents/NewComponents/NewUiHotels/HotelCard.jsx";
import DestinationGallery from "../../CustomComponents/NewComponents/NewDestinationSection/DestinationGallery.jsx";
import NewFooterUI from "../../CustomComponents/NewComponents/NewFooterUI/NewFooterUI.jsx";
import NewUIBookWithUs from "../../CustomComponents/NewComponents/NewUIBookWithUs/NewUIBookWithUs.jsx";
import NewUiSearchFormHotels from "../../CustomComponents/NewComponents/NewUiSearchForm/NewUiSearchFormHotels/NewUiSearchFormHotels.jsx";
import NewTestimonial from "../../CustomComponents/NewComponents/NewTestimonial/NewTestimonial.jsx";
import HotelaChain from "../../CustomComponents/NewComponents/NewUiHotels/HotelaChain.jsx";
import testimonialImg from "../../assets/images/new-testimonial.png";

function Accommodation() {
  const [footerDestinations, setFooterDestinations] = useState([]);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    // const isVerifiedToken = localStorage.getItem('isVerified');
    const AccountStatus = localStorage.getItem("AccountStatus");

    localStorage.removeItem("roomsData");
    localStorage.removeItem("storeRoomsData");
    // console.log(AccountStatus, "AccountStatus")
    // const role = localStorage.getItem('role');

    // console.log(isVerifiedToken, "token");
    // console.log(role, "role");

    if (AccountStatus === "disable") {
      console.error("Error: Invalid token or undefined for agent role");
      // showErrorToast("First Fill all required ")
      navigate("/agent-account");
    }
  }, [navigate]);

  useEffect(() => {
    fetchDestinations();
  }, []);

  const fetchDestinations = async () => {
    setLoader(true);

    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    // myHeaders.append(
    //   "Authorization",
    //   "Bearer " + localStorage.getItem("token")
    // );

    const formData = new FormData();

    // formData.append("limit", 10);
    formData.append("limit", 7);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: formData,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/destinations/fetch`,
        requestOptions
      );
      const result = await response.json();
      setFooterDestinations(result?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false); // Ensure loader is turned off
    }
  };

  return (
    <>
      <PageMetaData
        title="The Best Hotels in Himachal Pradesh, India -  Mountain Mysteries"
        description="Book hotels in Himachal Pradesh at the best budget tariffs. Explore our curated list of luxury and budget hotels with the best available prices. Compare rates and find the perfect stay with us!"
        keywords="Hotels In Himachal Pradesh"
      />
      <OgMetaTitles
        title="The Best Hotels in Himachal Pradesh, India -  Mountain Mysteries"
        type="Book hotels in Himachal Pradesh at the best budget tariffs. Explore our curated list of luxury and budget hotels with the best available prices. Compare rates and find the perfect stay with us!"
        url="https://www.mountainmysteries.com/accommodation/"
      />
      <NewUiSearchFormHotels />
      <section className="top_bottom_same_padding new_ui_bg">
        <HotelCard heading="Top Properties in Himachal Pradesh" />
      </section>
      <section className="top_bottom_padding_white">
        <DestinationGallery footerDestinations={footerDestinations} />{" "}
      </section>
      <section className="top_bottom_padding new_ui_bg" >
        <HotelaChain />
      </section>
      <section className="common_padding_testimonial">
        <div className="container">
          {" "}
          <div className="testimonial_flex_sec">
            <div>
              {" "}
              <h4 className="text_left new_ui_heading mb-10">
                Our Customers are Saying...
              </h4>
              <div className="google_rating">
                <div>
                  {" "}
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.8055 10.0415H21V10H12V14H17.6515C16.827 16.3285 14.6115 18 12 18C8.6865 18 6 15.3135 6 12C6 8.6865 8.6865 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C6.4775 2 2 6.4775 2 12C2 17.5225 6.4775 22 12 22C17.5225 22 22 17.5225 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z"
                      fill="#FFC107"
                    />
                    <path
                      d="M3.15283 7.3455L6.43833 9.755C7.32733 7.554 9.48033 6 11.9998 6C13.5293 6 14.9208 6.577 15.9803 7.5195L18.8088 4.691C17.0228 3.0265 14.6338 2 11.9998 2C8.15883 2 4.82783 4.1685 3.15283 7.3455Z"
                      fill="#FF3D00"
                    />
                    <path
                      d="M12.0002 22C14.5832 22 16.9302 21.0115 18.7047 19.404L15.6097 16.785C14.5721 17.5745 13.3039 18.0014 12.0002 18C9.39916 18 7.19066 16.3415 6.35866 14.027L3.09766 16.5395C4.75266 19.778 8.11366 22 12.0002 22Z"
                      fill="#4CAF50"
                    />
                    <path
                      d="M21.8055 10.0415H21V10H12V14H17.6515C17.2571 15.1082 16.5467 16.0766 15.608 16.7855L15.6095 16.7845L18.7045 19.4035C18.4855 19.6025 22 17 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z"
                      fill="#1976D2"
                    />
                  </svg>{" "}
                  RATING
                </div>
                <div className="mt-10">
                  <span> 4.7</span>{" "}
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8390"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="18"
                      height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8390)">
                      <path
                        d="M4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8390"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="18"
                      height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8390)">
                      <path
                        d="M4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8390"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="18"
                      height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8390)">
                      <path
                        d="M4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8390"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="18"
                      height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8390)">
                      <path
                        d="M4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8399"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="18"
                      height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8399)">
                      <path
                        d="M9.99935 6.58336V11.5L11.9993 13.0417L11.2493 10.5L13.1243 9.16669H10.791L9.99935 6.58336ZM4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </div>

            <div className="slider_sec">
              <NewTestimonial />{" "}
            </div>
          </div>
        </div>
      </section>
      <section className="new_ui_bg">
        <NewUIBookWithUs />{" "}
      </section>
      <NewFooterUI />
      {/* <BannerMain /> */}
      {/* <DestinationLinks
        footerDestinations={footerDestinations}
        heading="Our Exclusive Destinations"
        loader={loader}
      /> */}
      {/* <FilterHotels /> */}
      {/* <HotelsList heading="Top Properties in Himachal Pradesh" /> */}
      {/* <NewHotelsSearchForm
        topRadios={["Hotel", "B&B", "Camping", "HomeStay"]}
      /> */}
      {/* <HotelChains />
      <Testimonial /> */}
      {/* <Highlights /> */}
      {/* <DestinationLinks /> */}
      {/* <Footer /> */}
    </>
  );
}

export default Accommodation;
